import { MoneyDisplay } from "@/ds/custom/MoneyDisplay";
import { SmallProductDisplay } from "@/features/common/components/SmallProductDisplay";
import type { Money } from "@/lib/domain/Money";

export interface EvItemBreakdownTitleDisplayProps {
	imageUrl: string;
	productName: string;
	fcId: string;
	currentEstimatedValue: Money;
}

export const EvItemBreakdownTitleDisplay = (props: EvItemBreakdownTitleDisplayProps) => {
	return (
		<>
			<div className="flex items-center gap-2 p-3">
				<div className="min-w-0 flex-1">
					<SmallProductDisplay {...props} />
				</div>

				<div>
					<MoneyDisplay
						money={props.currentEstimatedValue}
						mode="Standard" />
				</div>
			</div>

			<div className="type-meta pl-3 pr-3">
				The pull rates used on this page have been pieced together from both official and community sources.  We&apos;ve done our
				best to make reasonable assumptions where necessary, including reducing the value of some bulk cards to account for their
				difficulty to sell as a single.  If a figure looks incorrect, we&apos;d love to hear your feedback on
				our <a href="https://discord.gg/RDYn8yDnFm" className="text-primary" target="_blank" rel="noopener noreferrer">official Discord</a> or
				alternatively email us at <a href="mailto:support@fyendalscollection.com" className="text-primary">support@fyendalscollection.com</a>
			</div>
		</>
	);
};
